// import {AuthModalVariant} from "../auth/components/auth_modal/AuthModalHeaderVariants";
// import {openAuthModal} from "../auth/state/auth_modal_slice";
import {useOpenPricesExperiment} from "../ab_testing/hooks/use_open_prices_experiment";
import {ApplicationSource, ApplicationSourceSection} from "../application/utils/form/application_form_source";
import {startRegistrationFlow} from "../auth/state/registration_flow_slice";
import {useAppDispatch} from "../store/hooks";
import {gtmEventPreFormOpen} from "../tracking/google_tag_manager/gtm_event_pre_form_open";
import {UserSource} from "../tracking/tracking_utils/user_source";
import {useShouldHidePrices} from "./use_should_hide_prices";

interface IUseHiddenPricesRegistrationHandlerParams {
    onAction: () => void;
    shouldShowPrice: boolean;
    gtmData: {
        clickText: string;
        source: string;
        vendorName: string;
        offerName: string;
        gtmSourceSection?: string;
    };
    propertyId?: number | null;
    offerId?: number | null;
    vendorId?: number | null;
    leadSource: ApplicationSource;
    leadSourceSection: ApplicationSourceSection;
}

export const useHiddenPricesRegistrationHandler = (params: IUseHiddenPricesRegistrationHandlerParams) => {
    const {onAction, shouldShowPrice, gtmData, propertyId, offerId, vendorId, leadSource, leadSourceSection} = params;
    const dispatch = useAppDispatch();
    const {hasCompleteProfile, hasPhoneVerified, isUserLoggedIn} = useShouldHidePrices();
    const {isAnonymousOpenPricesEnabled} = useOpenPricesExperiment();

    const handleClick = () => {
        if (shouldShowPrice || isAnonymousOpenPricesEnabled) {
            onAction();
            return;
        }

        gtmEventPreFormOpen(gtmData.clickText, gtmData.source, gtmData.vendorName, gtmData.offerName);

        dispatch(
            startRegistrationFlow({
                isUserLoggedIn,
                hasCompleteProfile,
                hasPhoneVerified,
                userSource: UserSource.HIDDEN_PRICES_BANNER,
                gtmSourceSection: gtmData.source,
                gtmClickText: gtmData.clickText,
                modalVariant: "hidden_prices_variant_b",
                propertyId: propertyId ?? undefined,
                offerId: offerId ?? undefined,
                vendorId: vendorId ?? undefined,
                useLeadAfterRegistration: !!propertyId,
                leadSource,
                leadSourceSection
            })
        );
    };

    return {
        handleClick
    };
};
// import {AuthModalVariant} from "../auth/components/auth_modal/AuthModalHeaderVariants";
// import {openAuthModal} from "../auth/state/auth_modal_slice";
import {useOpenPricesExperiment} from "../ab_testing/hooks/use_open_prices_experiment";
import {ApplicationSource, ApplicationSourceSection} from "../application/utils/form/application_form_source";
import {startRegistrationFlow} from "../auth/state/registration_flow_slice";
import {useAppDispatch} from "../store/hooks";
import {gtmEventPreFormOpen} from "../tracking/google_tag_manager/gtm_event_pre_form_open";
import {UserSource} from "../tracking/tracking_utils/user_source";
import {useShouldHidePrices} from "./use_should_hide_prices";

interface IUseHiddenPricesRegistrationHandlerParams {
    onAction: () => void;
    shouldShowPrice: boolean;
    gtmData: {
        clickText: string;
        source: string;
        vendorName: string;
        offerName: string;
        gtmSourceSection?: string;
    };
    propertyId?: number | null;
    offerId?: number | null;
    vendorId?: number | null;
    leadSource: ApplicationSource;
    leadSourceSection: ApplicationSourceSection;
}

export const useHiddenPricesRegistrationHandler = (params: IUseHiddenPricesRegistrationHandlerParams) => {
    const {onAction, shouldShowPrice, gtmData, propertyId, offerId, vendorId, leadSource, leadSourceSection} = params;
    const dispatch = useAppDispatch();
    const {hasCompleteProfile, hasPhoneVerified, isUserLoggedIn} = useShouldHidePrices();
    const {isAnonymousOpenPricesEnabled} = useOpenPricesExperiment();

    const handleClick = () => {
        if (shouldShowPrice || isAnonymousOpenPricesEnabled) {
            onAction();
            return;
        }

        gtmEventPreFormOpen(gtmData.clickText, gtmData.source, gtmData.vendorName, gtmData.offerName);

        dispatch(
            startRegistrationFlow({
                isUserLoggedIn,
                hasCompleteProfile,
                hasPhoneVerified,
                userSource: UserSource.HIDDEN_PRICES_BANNER,
                gtmSourceSection: gtmData.source,
                gtmClickText: gtmData.clickText,
                modalVariant: "hidden_prices_variant_b",
                propertyId: propertyId ?? undefined,
                offerId: offerId ?? undefined,
                vendorId: vendorId ?? undefined,
                useLeadAfterRegistration: !!propertyId,
                leadSource,
                leadSourceSection
            })
        );
    };

    return {
        handleClick
    };
};
